import { useMemo } from "react";
import { useFirestore } from "hooks/firestore/v2/useFirestore";
import { tournament } from "hooks/firestore/v2/models/tournament";
import { useSelector } from "hooks";
import { orderBy, type QueryConstraint, where } from "firebase/firestore";

const useTournaments = (titles: string[], tab?: "next" | "outrights") => {
  const userEventFilters = useSelector(
    (state) => state.auth?.attributes?.eventFilters,
  );

  const query = useMemo(() => {
    const queries: QueryConstraint[] = [orderBy("priority", "asc")];

    if (titles.length > 0) {
      queries.push(
        where(
          "sport",
          "in",
          titles.map((title) => title.toUpperCase()),
        ),
      );
    }

    if (tab === "next") {
      queries.push(where("next", "==", true));
    }

    if (tab === "outrights") {
      queries.push(where("outrights", "==", true));
    }

    if ((userEventFilters || []).length > 0) {
      queries.push(where("filters", "array-contains-any", userEventFilters));
    }

    return queries;
  }, [titles, tab, userEventFilters]);

  const { data, isLoading, error } = useFirestore(
    titles.length > 0 ? "/tournaments" : undefined,
    tournament.array(),
    {
      query,
      keyPath: "id",
    },
  );

  return {
    tournaments: data,
    isLoading,
    error,
  };
};

type Tournament = Exclude<
  ReturnType<typeof useTournaments>["tournaments"],
  undefined
>[0];

export { useTournaments, type Tournament };
